// ─── SOOTH+ THEME — theme.js ───

// ─── IMAGE ZOOM / LIGHTBOX ───
(function() {
  function initZoom() {
    var overlay = document.createElement('div');
    overlay.id = 'img-overlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:9999;cursor:zoom-out;align-items:center;justify-content:center;';
    var zImg = document.createElement('img');
    zImg.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:8px;box-shadow:0 40px 120px rgba(0,0,0,0.5);';
    overlay.appendChild(zImg);
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function() { overlay.style.display = 'none'; document.body.style.overflow = ''; });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { overlay.style.display = 'none'; document.body.style.overflow = ''; }});

    function attachZoom() {
      document.querySelectorAll('.product-main-img, .product-gallery-img').forEach(function(img) {
        if (img.dataset.zoomReady) return;
        img.dataset.zoomReady = '1';
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function() {
          zImg.src = img.src.replace(/(_\d+x\d*|_\d*x\d+)/, '').replace(/\?.*/, '') + '?width=1600';
          overlay.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        });
      });
    }
    attachZoom();
    setInterval(attachZoom, 1000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initZoom); } else { initZoom(); }
})();

// ─── PRODUCT IMAGE SWITCHER WITH ZOOM CLASS ───
(function() {
  function initSwitcher() {
    document.querySelectorAll('[onclick*="product-main-img"]').forEach(function(thumb) {
      var newSrc = thumb.getAttribute('onclick').match(/'([^']+)'/);
      if (!newSrc) return;
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function() {
        var main = document.querySelector('.product-main-img');
        if (main) { main.src = newSrc[1]; main.classList.add('product-main-img'); }
        document.querySelectorAll('[onclick*="product-main-img"]').forEach(function(t) { t.style.border = '2px solid transparent'; });
        thumb.style.border = '2px solid var(--amber)';
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initSwitcher); } else { initSwitcher(); }
  setInterval(initSwitcher, 500);
})();

// Countdown Timer (bis Mitternacht)
(function() {
  var h = document.getElementById('cd-h');
  var m = document.getElementById('cd-m');
  var s = document.getElementById('cd-s');
  if (!h) return;
  function tick() {
    var end = new Date(); end.setHours(23,59,59,0);
    var diff = end - new Date();
    if (diff <= 0) return;
    h.textContent = String(Math.floor(diff/3600000)).padStart(2,'0');
    m.textContent = String(Math.floor((diff%3600000)/60000)).padStart(2,'0');
    s.textContent = String(Math.floor((diff%60000)/1000)).padStart(2,'0');
  }
  tick(); setInterval(tick, 1000);
})();

// Sticky Buy Bar
(function() {
  var bar = document.getElementById('stickyBuy');
  if (!bar) return;
  window.addEventListener('scroll', function() {
    bar.classList.toggle('visible', window.scrollY > 600);
  }, { passive: true });
})();

// Add to Cart — Feedback
(function() {
  document.querySelectorAll('.btn-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (btn.tagName === 'BUTTON') {
        var orig = btn.textContent;
        btn.textContent = '✓ Hinzugefügt!';
        btn.style.background = '#2ECC71';
        setTimeout(function() {
          btn.textContent = orig;
          btn.style.background = '';
        }, 2000);
      }
    });
  });
})();

// ─── SCROLL ANIMATIONS (Intersection Observer) ───
(function() {
  var style = document.createElement('style');
  style.textContent = [
    '[data-animate]{opacity:0;transform:translateY(40px);transition:opacity 0.7s cubic-bezier(.22,.68,0,1.2),transform 0.7s cubic-bezier(.22,.68,0,1.2)}',
    '[data-animate].in-view{opacity:1;transform:none}',
    '[data-animate][data-delay="1"]{transition-delay:0.1s}',
    '[data-animate][data-delay="2"]{transition-delay:0.2s}',
    '[data-animate][data-delay="3"]{transition-delay:0.3s}',
    '[data-animate][data-delay="4"]{transition-delay:0.4s}',
    '[data-animate][data-delay="5"]{transition-delay:0.5s}',
    '[data-animate="left"]{transform:translateX(-40px)}',
    '[data-animate="left"].in-view{transform:none}',
    '[data-animate="right"]{transform:translateX(40px)}',
    '[data-animate="right"].in-view{transform:none}',
    '[data-animate="scale"]{transform:scale(0.88);opacity:0}',
    '[data-animate="scale"].in-view{transform:scale(1);opacity:1}',
  ].join('');
  document.head.appendChild(style);

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function(el){ el.classList.add('in-view'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  function observe() {
    document.querySelectorAll('[data-animate]').forEach(function(el) {
      observer.observe(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Fallback: IO meldet auf manchen Mobile-Viewports ratio 0 für sichtbare Elemente
  // (Content blieb unsichtbar über dunklen Sektionen). Rect-basierter Reveal deckt das ab.
  var revealPending = false;
  function revealByRect() {
    revealPending = false;
    document.querySelectorAll('[data-animate]:not(.in-view)').forEach(function(el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.94 && r.bottom > 0) el.classList.add('in-view');
    });
  }
  function queueReveal() {
    if (revealPending) return;
    revealPending = true;
    requestAnimationFrame(revealByRect);
  }
  window.addEventListener('scroll', queueReveal, { passive: true });
  window.addEventListener('resize', queueReveal, { passive: true });
  setTimeout(revealByRect, 600);
  setInterval(function() {
    if (document.querySelector('[data-animate]:not(.in-view)')) revealByRect();
  }, 1500);
})();

// ─── PARALLAX HERO ───
(function() {
  var hero = document.querySelector('.hero__image-wrap, .hero__media');
  if (!hero) return;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    if (y < window.innerHeight * 1.5) {
      hero.style.transform = 'translateY(' + (y * 0.25) + 'px)';
    }
  }, { passive: true });
})();

// ─── NUMBER COUNTER ANIMATION ───
(function() {
  function animateCount(el) {
    var target = parseFloat(el.dataset.count || el.textContent.replace(/[^0-9.]/g, ''));
    var suffix = el.textContent.replace(/[0-9.]/g, '');
    var start = 0;
    var duration = 1600;
    var startTime = null;
    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = start + (target - start) * ease;
      el.textContent = (Number.isInteger(target) ? Math.round(current) : current.toFixed(1)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    el.dataset.count = target;
    requestAnimationFrame(step);
  }

  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.stat__num, [data-count]').forEach(function(el) {
    obs.observe(el);
  });
})();

// Variant selector highlight
(function() {
  document.querySelectorAll('input[type="radio"][name^="option_"]').forEach(function(input) {
    input.addEventListener('change', function() {
      var name = this.name;
      document.querySelectorAll('input[name="' + name + '"]').forEach(function(sib) {
        var span = sib.nextElementSibling;
        if (span) span.style.borderColor = sib.checked ? 'var(--amber)' : 'var(--border)';
      });
    });
  });
})();

// ─── GENERIC PARALLAX (data-parallax + data-speed) ───
(function() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Scroll-gekoppelter Parallax läuft auf dem Haupt-Thread, natives Touch-Scrolling
  // auf dem Compositor — auf Mobile laufen sie immer minimal auseinander (Ruckeln).
  // Auf einem Vollbild-Hero ist das nicht ruckelfrei lösbar. Deshalb: Mobile statisch
  // (Bild sitzt neutral), Parallax nur auf Desktop. Andere Sektionen dürfen dezent.
  var isMobile = window.matchMedia('(max-width: 960px)').matches
    || ('ontouchstart' in window && window.matchMedia('(pointer: coarse)').matches);
  if (isMobile) {
    // Sicherstellen, dass kein Transform hängen bleibt → Bild absolut ruhig.
    document.querySelectorAll('[data-parallax]').forEach(function(el){ el.style.transform = 'none'; });
    return;
  }
  var mobileDamp = 1;
  var ease = 0.10;      // Annäherung pro Frame
  var els = [];
  function collect() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')).map(function(el){
      el.style.willChange = 'transform';
      el.style.backfaceVisibility = 'hidden';
      return { el: el, speed: parseFloat(el.dataset.speed || '0.1') * mobileDamp, cur: 0, target: 0 };
    });
  }
  function computeTargets() {
    var vh = window.innerHeight;
    els.forEach(function(p) {
      var rect = p.el.getBoundingClientRect();
      if (rect.bottom < -300 || rect.top > vh + 300) return; // außerhalb: Ziel nicht ändern
      var center = rect.top + rect.height / 2 - vh / 2;
      p.target = -center * p.speed;
    });
  }
  var raf = null;
  function loop() {
    var moving = false;
    els.forEach(function(p) {
      var diff = p.target - p.cur;
      if (Math.abs(diff) > 0.15) { p.cur += diff * ease; moving = true; }
      else { p.cur = p.target; }
      p.el.style.transform = 'translate3d(0,' + p.cur.toFixed(2) + 'px,0)';
    });
    raf = moving ? requestAnimationFrame(loop) : null;
  }
  function kick() { computeTargets(); if (!raf) raf = requestAnimationFrame(loop); }
  function init() { collect(); computeTargets(); els.forEach(function(p){ p.cur = p.target; }); loop(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick, { passive: true });
})();

// ─── COPY-/BILD-SCHUTZ (Deterrent gegen Content-Klau) ───
(function() {
  // Rechtsklick-Menü unterbinden (Bild speichern / Quelltext)
  document.addEventListener('contextmenu', function(e) {
    // Formularfelder ausnehmen, damit Nutzer normal tippen/einfügen können
    var t = e.target;
    if (t && (t.closest('input') || t.closest('textarea'))) return;
    e.preventDefault();
  });
  // Bilder nicht per Drag herausziehen
  document.addEventListener('dragstart', function(e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });
  // Beim Kopieren von Text automatisch Quellenhinweis anhängen
  document.addEventListener('copy', function(e) {
    var sel = (window.getSelection && window.getSelection().toString()) || '';
    if (sel.length > 30 && e.clipboardData) {
      e.clipboardData.setData('text/plain', sel + '\n\n© sooth+ · sooth-light.com — Inhalt urheberrechtlich geschützt.');
      e.preventDefault();
    }
  });
})();
